import type { FinanceOptionType } from "../../../../common-deprecated/types/CommonTypes";
import type { UscCheckoutType } from "../../../shared-logic/types/UscCommonTypes";

export const USC_BASKET_SET_FINANCE_OPTION = "uscBasket/setFinanceOption";
export const USC_BASKET_SET_CHECKOUT_TYPE = "uscBasket/setCheckoutType";

export type SetFinanceOption = {
    type: typeof USC_BASKET_SET_FINANCE_OPTION;
    option: FinanceOptionType;
    disableQueryUpdate: boolean; // OR-5042, this is used to prevent propagating the financeOption to query on init.
};

export const setFinanceOption = (option: FinanceOptionType, disableQueryUpdate: boolean = false): SetFinanceOption => ({
    type: USC_BASKET_SET_FINANCE_OPTION,
    option,
    disableQueryUpdate,
});

export type SetCheckoutType = {
    type: typeof USC_BASKET_SET_CHECKOUT_TYPE;
    checkoutType: UscCheckoutType | null;
};

export const setCheckoutType = (checkoutType: UscCheckoutType | null): SetCheckoutType => ({
    type: USC_BASKET_SET_CHECKOUT_TYPE,
    checkoutType,
});

export type UscBasketActionsType = SetFinanceOption | SetCheckoutType;
